export default __webpack_public_path__ + "static/placeholder-16-9-a7c7f5c150e9c2407a7a52a0ac23e1b0.png";